import React from "react";
import OwnNetwork from "../../images/abn-network-services/manage-network.svg";
import Marketplace from "../../images/abn-network-services/marketplace.svg";
import OnboardingService from "../../images/abn-network-services/onboarding.svg";

import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function ABNMainServices() {
 const services = [
  {
    img: OwnNetwork,
    title: "Digital Sub-Network",
    subtitle: "Create Decentralized Micro Rural Networks",
    bodycopy:
      "Build your own decentralized, micro-level rural network powered by local entrepreneurs including farmers, processors, storage providers, and transporters. This enables you as network participant to organize and manage local trade, production, and logistics as a connected ecosystem.",
    points: [
      "Organize agri micro-entrepreneurs (farmers, beekeepers, producers)",
      "Enable processing micro-entrepreneurs for value addition",
      "Integrate storage micro-entrepreneurs for aggregation",
      "Connect with local micro-transporters for last-mile logistics",
    ],
    cta: "Create a distributed, self-sustaining rural ecosystem",
  },
  {
    img: Marketplace,
    title: "Marketplace Access",
    subtitle: "Connect. Trade. Grow.",
    bodycopy:
      "Access a trusted digital marketplace to unlock demand and new revenue opportunities. Connect with buyers, sellers, and partners while enabling secure, transparent transactions across your network..",
    points: [
      "Connect with buyers, sellers, and partners",
      "Discover real-time demand and pricing",
      "Enable secure, transparent transactions",
      "Build strategic partnerships",
    ],
    cta: "Expand into a larger digital market",
  },
  {
    img: OnboardingService,
    title: "Onboarding & Network Setup",
    subtitle: "Launch Your Local & Rural Network",
    bodycopy:
      "Set up and activate your own decentralized network with expert support. From onboarding local participants to integrating into the broader ecosystem, everything is designed for a smooth and scalable launch..",
    points: [
      "Guided setup for trade, production, and logistics networks",
      "Agent-assisted onboarding of local participants",
      "Seamless integration into the ecosystem",
      "Continuous support for scaling and performance",
    ],
    cta: "Go live with a network you own and control",
  },
  {
    img: OwnNetwork,
    title: "Global Network Access",
    subtitle: "Discover & Connect with Trusted Agribusinesses",
    bodycopy:
      "Explore and connect with verified small and medium agribusinesses across the network. Discover new partners, view digital profiles, and build cross-regional trade relationships beyond your local ecosystem..",
    points: [
      "Discover trusted network participants globally",
      "View digital brochures and business profiles",
      "Directly connect and collaborate with partners",
      "Build cross-regional trade and supply relationships",
    ],
    cta: "Move from local presence to a globally connected ecosystem",
  },
  {
    img: Marketplace,
    title: "Community Support (CS Network)",
    subtitle: "Access Advisory, Training & Ecosystem Support",
    bodycopy:
      "Leverage a structured community support system led by regional agribusinesses. Access advisory services, training programs, and continuous guidance to strengthen your operations and capabilities..",
    points: [
      "Access advisory services and expert guidance",
      "Participate in training and capacity-building programs",
      "Get updates on schemes, best practices, and innovations",
      "Receive ongoing operational and business support",
    ],
    cta: "Strengthen capabilities with a continuous support ecosystem",
  },
    {
    img: Marketplace,
    title: "Earn & Grow with the Network",
    subtitle: " To be decided later",
    bodycopy:
      "Start earning from day one by contributing to network growth and participation. Refer farmers, agribusinesses, and innovators in your locality and earn performance-based incentives linked to real activity, while building a stronger ecosystem around you.",
    points: [
      "Access advisory services and expert guidance",
      "Participate in training and capacity-building programs",
      "Get updates on schemes, best practices, and innovations",
      "Receive ongoing operational and business support",
    ],
    cta: "Strengthen capabilities with a continuous support ecosystem",
  },
];
  return (
    <div className="">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
         Services for Participants
       {/*   <p>Build, connect, and grow through decentralized rural networks and trusted ecosystem access </p> */}
      </h2>
      <Row>
        {services.map((e,index) => {
          return (
            <Col md={4} className="d-flex" key={index}>
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
